var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Linkedin = function (_a) {
    var color = _a.color, background = _a.background, props = __rest(_a, ["color", "background"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40" }, props),
        React.createElement("g", { fill: "none" },
            React.createElement("path", { fill: background, className: "ic_background", d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20z" }),
            React.createElement("path", { fill: color, className: "ic_filling", d: "M14.708 29V14.83h-4.445V29h4.445zm-2.223-16.104c1.55 0 2.515-1.088 2.515-2.448C14.971 9.058 14.035 8 12.515 8S10 9.058 10 10.448c0 1.36.965 2.448 2.456 2.448h.03zM18 29h4.586v-7.639c0-.409.03-.817.151-1.11.332-.816 1.086-1.662 2.354-1.662 1.66 0 2.323 1.254 2.323 3.093V29H32v-7.843C32 16.955 29.737 15 26.72 15c-2.474 0-3.56 1.371-4.164 2.305h.03V15.32H18C18.06 16.605 18 29 18 29z" }))));
};
Linkedin.defaultProps = {
    background: '#555',
    color: '#151515',
};
export default Linkedin;
//# sourceMappingURL=Linkedin.js.map